<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">
      Data Peserta
      <CButton
        color="danger"
        style="float:right;margin-right:10px"
        class="btn-md ml-auto"
      >Ekspor PDF</CButton>
      <CDropdown
        toggler-text="Ekspor Excel"
        color="warning"
        class="mr-2 d-inline-block text-white float-right"
      >
        <CDropdownItem>Ekspor Semua</CDropdownItem>
        <CDropdownItem>Ekspor Beberapa Data</CDropdownItem>
      </CDropdown>
    </CCardHeader>
    <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
       <li class="nav-item">
        <router-link
          to="/sertifikasi/data-peserta"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          style="background-color: #214073 !important;"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Anggota</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/sertifikasi/data-peserta/calon-anggota"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          style="background-color: #486ba7;"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >Calon Anggota</router-link>
      </li>
    </ul>
    <!-- Data Data Peserta -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <CInput
              label="Pencarian"
              class="float-right"
              placeholder="Cari Data .."
              @keyup="cariData"
              v-model="search"
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol sm="6" lg="12">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{ index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #no_keanggotaan="{item}">
              <td class="py-2">{{ item.no_keanggotaan ? item.no_keanggotaan : '-' }}</td>
            </template>
            <template #nama="{item}">
              <td class="py-2">{{ item.nama ? item.nama_lengkap : '-' }}</td>
            </template>
            <template #email="{item}">
              <td class="py-2">{{ item.email ? item.email : '-' }}</td>
            </template>
            <template #no_telephone="{item}">
              <td class="py-2">{{ item.no_telephone ? item.no_telephone : '-' }}</td>
            </template>
            <template #updated_at="{item}">
              <td class="py-2">{{ item.updated_at ? item.updated_at : '-' }}</td>
            </template>
            <template #_status="{item}">
              <td class="py-2">
                <font-awesome-icon icon="check" class="text-success" v-if="item._status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item}">
              <td class="py-2 text-center">
                <!-- <router-link to="/sertifikasi/data-peserta-sertifikasi/data-diri"> -->
                <router-link :to="'/sertifikasi/data-peserta-sertifikasi/data-diri/'+item.id_user">
                  <CButton color="warning" class="btn-sm" square>
                    <i class="fa fa-user text-white" aria-hidden="true"></i>
                  </CButton>
                </router-link>&nbsp;&nbsp;
                <router-link :to="'/sertifikasi/data-peserta-sertifikasi/'+item.id_user">
                  <CButton color="success" class="btn-sm" square>
                    <i class="fa fa-file" aria-hidden="true"></i>
                  </CButton>
                </router-link>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>

    </CCardBody>
    <!-- End Data Jadwal TC -->
  </CCard>
</template>
<script>
import DataPesertaService from "../../../services/sertifikasi/data-peserta.service";

import DataKeanggotaanService from "../../../services/keanggotaan/data-anggota.service"

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "no_keanggotaan",
    label: "No. Agt IAPI",
    sorter: true,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false
  },
  // {
  //   key: "level",
  //   label: "Level",
  //   sorter: true,
  //   filter: false
  // },
  {
    key: "email",
    label: "Email",
    sorter: true,
    filter: false
  },
  {
    key: "no_telephone",
    label: "No. Telepon",
    sorter: true,
    filter: false
  },
  {
    key: "updated_at",
    label: "Terakhir Update",
    sorter: true,
    filter: false
  },

  {
    key: "aksi",
    _style: "width:10%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Master RPL",
  data() {
    return {
      items: [],
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Choose File...",
      fields,
      search: "",
      pageSize: "",
      currentPage: 0,
      pagination: {
        totalPages: 0
      },
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed : 0,
      collapseDuration: 0,
      content: [],
      loading: true
    };
  },
  mounted() {
    this.getDataPeserta("0","10","default");
  },
  watch: {
    currentPage: function(val) {
      var page = val - 1;
      this.indexed = page * 10;
      this.getDataPeserta(val - 1, this.pageSize, this.search);
    }
  },
  
  methods: {
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getDataPeserta("0", pageSize, this.search);
    },

    cariData() {
      this.getDataPeserta("0", this.pageSize, this.search);
    },

    pageChange() {
      this.getDataPeserta(currentPage, this.pageSize, this.search);
    },
    dataDiri() {
      this.$route.push({ path: "/sertifikasi/data-peserta/data-diri" });
    },
    getDataPeserta(currentPage,pageSize,filter){
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      DataKeanggotaanService.getCalonAnggota(currentPage,pageSize,filter)
        .then(response => {
          // comment console console.log(response);
          vm.items = response.data.data.content;

          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber;
          setTimeout(() => loader.hide(), 1000);
        })
        .catch(error => {
          // comment console console.log(error);
        });
    }
  }
};
</script>